import { SITE_URL } from '../resolveSEO';

export const buildWebSite = (description: string) => ({
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'Airhead Games',
  description,
  publisher: {
    '@id': `${SITE_URL}/#organization`,
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/join?{search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
});
